import { Controller } from "@hotwired/stimulus"

// Submits the surrounding form on Cmd/Ctrl + Enter.
export default class extends Controller {
  submit(event) {
    event.preventDefault()
    this.element.closest("form")?.requestSubmit()
  }
}
